export default __webpack_public_path__ + "static/media/GRAPHIC_SEASONAL_SYSTEM.fc66ff9b.png";